import { Logout, LogoutOutlined } from "@mui/icons-material";
import { useLocation } from "@reach/router";
import { navigate } from "gatsby";
import React from "react";
import { Container, MenuDesktop, MenuMobile } from "./styles";

import { LacreiIcon1 } from "../../../assets/icons";
import Button from "../../form/Button";

/**
 * Componente de cabeçalho.
 * @param {object} props - Propriedades do componente.
 * @param {boolean} [props.isLogged=false] - Indica se o usuário está logado.
 * @returns {JSX.Element} O componente Header.
 */
export default function Header({ isLogged = false }) {
  const { pathname } = useLocation();

  function logout() {
    if (isLogged) {
      isLogged = false;
      sessionStorage.removeItem("authToken");
      navigate("/");
    }
  }

  function navigateToHelp() {
    logout();
    navigate(`${process.env.GATSBY_PUBLIC_URL_INSTITUCIONAL}/ajuda`);
  }

  const logoRedirectRoute = typeof window !== "undefined" && sessionStorage.getItem("authToken") ? "/saude/painel-inicial" : "/";

  return (
    <Container id="header">
      <div className="logo">
        <a href={logoRedirectRoute} rel="noreferrer" aria-label="Link para o site institucional da Lacrei Saúde">
          <LacreiIcon1 />
        </a>
      </div>
      <MenuDesktop>
        <Button title="Ajuda" type="button" onClick={() => navigateToHelp()} shadowy noLink isVariant labelAccessibility="Ajuda" />
        {isLogged && pathname !== "/saude/cadastro-diversidade" && pathname !== "/saude/cadastro-diversidade/" && (
          <button onClick={logout} className="logout" aria-label="Sair">
            <LogoutOutlined />
          </button>
        )}
      </MenuDesktop>
      <MenuMobile isLogged={isLogged}>
        <button aria-label="Ajuda" type="button" onClick={() => navigateToHelp()}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 16H11V14H9V16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8H8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 10 9 9.75 9 13H11C11 10.75 14 10.5 14 8C14 5.79 12.21 4 10 4Z"
              fill="#018762"
            />
          </svg>
        </button>
        {pathname !== "/saude/cadastro-diversidade" && pathname !== "/saude/cadastro-diversidade/" && (
          <button aria-label="Sair">{isLogged && <Logout onClick={logout} />}</button>
        )}
      </MenuMobile>
    </Container>
  );
}
